/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Example_Total_OverflowInputs */

const en_us2_chat_example_total_overflow = /** @type {(inputs: Chat_Example_Total_OverflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the total overflow for the storm from last Friday?`)
};

const en_gb2_chat_example_total_overflow = /** @type {(inputs: Chat_Example_Total_OverflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the total spill for the storm from last Friday?`)
};

/**
* | output |
* | --- |
* | "What was the total overflow for the storm from last Friday?" |
*
* @param {Chat_Example_Total_OverflowInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const chat_example_total_overflow = /** @type {((inputs?: Chat_Example_Total_OverflowInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Example_Total_OverflowInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_chat_example_total_overflow(inputs)
	return en_us2_chat_example_total_overflow(inputs)
});